<template>
  <el-container class="lad-reviews--wrapper">
    <el-aside>
      <LadAffix
        relative-element-selector="#lad-reviews--main-reviews"
        :offset="{ top: top, bottom: 20 }"
        :enabled="!isMobile"
      >
        <div class="lad-reviews-sidebar--wrapper">
          <h2>{{ $t(`${base}.title`) }}</h2>
          <p>{{ $t(`${base}.description`) }}</p>
        </div>
      </LadAffix>
    </el-aside>
    <el-main id="lad-reviews--main-reviews">
      <LadReviewsList :uuid="uuid" />
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { hydrateWhenIdle } from 'vue-lazy-hydration'

export default {
  name: 'LadReviewsExperience',
  components: {
    LadReviewsList: hydrateWhenIdle(() =>
      import(
        /* webpackChunkName: "lad-reviews-list" */ '@/components/reviews/section'
      )
    ),
  },
  props: {
    top: { type: Number, default: 40 },
  },
  data() {
    return {
      base: 'experience.sidebars.reviews',
    }
  },
  computed: {
    ...mapState('experience', {
      uuid: (state) => state.experience.uuid,
    }),
    ...mapGetters('device', ['isMobile']),
  },
}
</script>

<style lang="scss">
.lad-reviews {
  .lad-reviews-sidebar--wrapper {
    padding-right: 15px;
  }

  @media screen and (max-width: 1026px) {
    &--wrapper {
      .el-aside {
        padding-left: 20px;
        padding-right: 20px;
      }
      .el-main {
        margin-top: 20px;
      }
    }
  }

  @media screen and (max-width: 700px) {
    &--wrapper {
      .el-main {
        padding-top: 0;
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}
</style>
